// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBkbM5kXqsxgo_p8hav-gyvxn44VM-cQQw",
  authDomain: "mit-pd-chatbots.firebaseapp.com",
  projectId: "mit-pd-chatbots",
  storageBucket: "mit-pd-chatbots.firebasestorage.app",
  messagingSenderId: "273699837303",
  appId: "1:273699837303:web:7577dd5f0ec20221023d72",
  measurementId: "G-KYEHDHQZQF"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);
const auth = getAuth(app);

export { auth };